import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import { faBars } from "@fortawesome/pro-solid-svg-icons";
import { NavButton } from "../../buttons";
import { Icon } from "../../widgets";
import { NAV_LINKS } from "../constants";
import "./styles.scss";
interface BottomNavProps {
  readonly onToggleMenu: () => void;
  readonly hasSideDrawer?: boolean;
}
export const BottomNav: FC<BottomNavProps> = t0 => {
  const $ = _c(5);
  const {
    onToggleMenu,
    hasSideDrawer
  } = t0;
  let t1;
  if ($[0] !== hasSideDrawer || $[1] !== onToggleMenu) {
    t1 = hasSideDrawer ? <>{NAV_LINKS.filter(_temp).map(_temp2)}<button className="bottom-nav__menu-button" onClick={onToggleMenu} type="button"><Icon icon={faBars} /></button></> : NAV_LINKS.map(_temp3);
    $[0] = hasSideDrawer;
    $[1] = onToggleMenu;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <nav className="bottom-nav">{t1}</nav>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
function _temp(props) {
  return props.href !== "/settings/profile";
}
function _temp2(props_0) {
  return <NavButton {...props_0} key={props_0.href} />;
}
function _temp3(props_1) {
  return <NavButton {...props_1} key={props_1.href} />;
}